import { serverHttp } from "@/plugins/axios";

export const getOrderPaymentUrl = async function(params: object) {
    return serverHttp.get("/api/online-payment/order-info", {
        params: params
    });
};
